/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
// import ChildTraining from "components/widgets/training/CompletedTraining";
import { connect } from "react-redux";
import containsLongRunningProcess from "components/hoc/containsLongRunningProcess";
import requireAuth from "components/hoc/requireAuth";
import DesktopBreakpoint from "util/responsive/desktop_breakpoint";
import TabletBreakpoint from "util/responsive/tablet_breakpoint";
import { Trans } from "react-i18next";
import i18n from "i18next";
import toastr from "toastr";
import { upsertEmployeeRole, cancelEmployeeRole } from "actions";

class EmployeeRole extends Component {
  rowClassName = "";
  state = {
    showingChildren: false,
  };

  upsertRole = (employeeId, roleId) => {
    this.props.upsertEmployeeRole(
      employeeId,
      roleId,
      this.onBegin,
      this.onSuccess,
      this.onError
    );
  };

  cancelRole = (employeeRoleId) => {
    this.props.cancelEmployeeRole(
      employeeRoleId,
      this.onBegin,
      this.onSuccess,
      this.onError
    );
  };

  onBegin = () => {
    this.props.onProcessBegin();
  };

  onError = (err) => {
    console.log(err);
    toastr.error(err.response.data.message);
    this.props.onProcessEnd();
  };

  onSuccess = () => {
    this.props.onProcessEnd();
    this.props.refresh();
  };

  toggleChildren = () => {
    let showingChildren = this.state.showingChildren;
    this.setState({ showingChildren: !showingChildren });
  };

  renderTabletModeDetail = (role) => {
    if (!this.state.showingChildren) {
      return null;
    }
    return (
      <tr className="child">
        <td className="child" colSpan="2">
          <table>
            <tbody>
              <tr data-dt-row="0" data-dt-column="1">
                <td>
                  <div className="tableTitle">
                    <Trans desc="Durum">10547</Trans>
                  </div>
                </td>
                <td className="showGrup">{this.renderRoleStatus(role)}</td>
              </tr>
              <tr data-dt-row="0" data-dt-column="2">
                <td></td>
                <td>{this.renderActionButton(role)}</td>
              </tr>
            </tbody>
          </table>
        </td>
      </tr>
    );
  };

  renderRoleStatus = (role) => {
    if (role.roleStatus === "None") return "";
    else if (role.roleStatus === "Candidate") return i18n.t("10550");
    else if (role.roleStatus === "Member") return i18n.t("10551");
    else return "";
  };

  renderActionButton = (role) => {
    if (role.isRegistered)
      return (
        <button
          className="btn-action btn-cancel"
          onClick={() => this.cancelRole(role.employeeRoleId)}
        >
          <Trans desc="İptal">10549</Trans>
        </button>
      );
    else
      return (
        <button
          className="btn-action btn-save"
          onClick={() => this.upsertRole(role.employee.id, role.role.id)}
        >
          <Trans desc="Kaydet">10548</Trans>
        </button>
      );
  };

  render() {
    const { role } = this.props;
    return (
      <>
        {this.props.spinner}
        <DesktopBreakpoint>
          <tr>
            <td className="showGrup">{role.employee.name}</td>
            <td className="showGrup">{role.role ? role.role.name : ""}</td>
            <td className="showGrup">{this.renderRoleStatus(role)}</td>
            <td className="showGrup">{role.dealer?.name}</td>
            <td className="showGrup">{this.renderActionButton(role)}</td>
          </tr>
        </DesktopBreakpoint>
        <TabletBreakpoint>
          <tr
            className={this.rowClassName}
            onClick={() => this.toggleChildren()}
          >
            <td className="showGrup">{role.employee.name}</td>
            <td className="showGrup">{role.role ? role.role.name : ""}</td>
          </tr>
          {this.renderTabletModeDetail(role)}
        </TabletBreakpoint>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {};
};

export default connect(mapStateToProps, {
  upsertEmployeeRole,
  cancelEmployeeRole,
})(containsLongRunningProcess(requireAuth(EmployeeRole)));
